import { Injectable } from '@angular/core';
import { Medici } from '../models/nomenclatoare.model';
import { LocalStorageService } from './local-storage.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {catchError} from 'rxjs/operators/catchError';
import { Observable } from 'rxjs';
import { serverurl } from './server.service';

const cudOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' })};


@Injectable({
  providedIn: 'root'
})

export class MediciService {
  public medici: Medici [] = []
  public localstorageflag = 0;
  private server_url=serverurl+"/api/v1/medic/";
  // private server_url="http://localhost/api/v1/medic/";
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) {
    let data = this.localStorageService.get("Medici");
    // console.log("On Initi DAta Local storage => ",data)
    if (data)
    {
      this.localstorageflag = 1;
      this.medici = data;
      this.medici.forEach(element=> {
        this.http.post<Medici>(this.server_url, element, cudOptions).pipe(
          catchError(this.handleError)
            )
          });
      }
    else {
      // console.log("PacientList nu este Local")
    }

   }

  getMedici(){
    return this.medici;
  }

  updateMediciToServer(id,medic_details){
    return this.http.put(this.server_url+id,medic_details,this.httpOptions)
  }
  getMediciFromServer(){
    return this.http.get<Medici[]>(this.server_url)
  }
  addMedicToServer(newMedic){
    return(this.http.post<any>(this.server_url,newMedic,this.httpOptions))
  }
  addMedici(newMedic){
    newMedic.id = this.medici.length+1
    this.medici.push(newMedic);
    if (this.localstorageflag){
      this.localStorageService.remove("Medici");
      this.addtolocalStorage(this.medici);
    }
    else {
      this.addtolocalStorage(this.medici);
    }
    console.log("Lista pacienti din pacienti service =>", this.medici);

    return this.http.post<Medici>(this.server_url, newMedic, cudOptions).pipe(
      catchError(this.handleError)
    );
  }
  addtolocalStorage(PacientList){
    console.log("addtolocalstorage CategorieServicii: =>", PacientList);
    console.log("Addtolocalstorage",this.localStorageService.set("Medici", PacientList));
  }
  private handleError(error: Response){
    console.log("Error from Pacient Service: => " + error)
    return Observable.throw("500 internal server error" )
  }
}
